import { render, staticRenderFns } from "./icon-features.vue?vue&type=template&id=7e89fada&scoped=true&"
import script from "./icon-features.vue?vue&type=script&lang=js&"
export * from "./icon-features.vue?vue&type=script&lang=js&"
import style0 from "./icon-features.vue?vue&type=style&index=0&id=7e89fada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e89fada",
  null
  
)

export default component.exports